export default __webpack_public_path__ + "static/media/photo2.27a6f8df.png";